// extracted by mini-css-extract-plugin
var _1 = "toiXMkvYMnZ4XpcXZCEa";
export { _1 as "input" }
